"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Button_1 = __importDefault(require("@mui/material/Button"));
const styled_1 = __importDefault(require("@emotion/styled"));
exports.default = (0, styled_1.default)(Button_1.default) `
  width: 100%;
  height: 56px;
  padding: 0 8px;
  border-radius: 12px;
  color: var(--white);
  background-color: var(--primary-main);
  :hover {
    background-color: var(--primary-main);
  }
  &.Mui-disabled {
    color: var(--gray-30);
    background-color: var(--surface-bg);
  }
`;
